module.exports = __webpack_public_path__ + "assets/img/Play11.aa3bdda7.png";